import englishMessages from 'ra-language-english';

export default {
  websites_create: '+ ADD NEW WEBSITE',
  domains_create: '+ ADD NEW DOMAIN',
  domains_create_small: '+',
  tracking_definition_create: '+ ADD COOKIE DEFINITION',
  custom_scan_cookie_create: '+ ADD CUSTOM COOKIE',
  cancel: 'CANCEL',
  consent_solution_create: '+ Create new consent solution',
  consent_solution_create_small: '+',
  mobile_consent_solution_create: '+ Create mobile consent solution',
  mobile_consent_solution_create_small: '+',
  consent_item_create: '+ Create consent item',
  consent_item_create_small: '+',
  team_mates_create: '+ Add teammate',
  team_mates_create_small: '+',
  mobile_consent_solution_save_success: 'Mobile consent solution saved',
  mobile_consent_solution_save_fail: 'Mobile consent solution save failed due to an error. %{message}',
  custom_scan_cookie_save_success: 'Custom cookie saved',
  custom_scan_cookie_save_fail: 'Custom cookie save failed due to an error. %{message}',
  missing_universal_consent_solution: 'There is no such universal consent solution',
  universal_consent_item_save_success: 'Universal consent item saved',
  universal_consent_item_save_fail: 'Universal consent item save failed due to an error. %{message}',
  universal_consent_item_load_fail: 'There was an error when loading consent item',
  website_save_success: 'Website saved',
  website_save_fail: 'Website save failed due to an error. %{message}',
  payment_info_save_success: 'Payment info saved',
  payment_info_save_fail: 'Payment info save failed due to an error. %{message}',
  consent_items_count: '1 |||| %{smart_count}',
  domain: {
    types: {
      website: 'Public Domain',
      internal_alias: 'Internal Test Domain',
      external_alias: 'Public Test Site',
    },
  },
  summary: {
    consent_solution: 'Consent Solution per domain',
    freq_30: 'Scanned Monthly',
    freq_7: 'Scanned Weekly',
    freq_1: 'Scanned Daily',
    depth_500: 'Up to 500 URL`s',
    depth_5000: 'Up to 5000 URL`s',
    depth_15000: 'Up to 15000 URL`s',
    products_title: 'Choose products and a plan that suits your needs',
    products_subtitle: 'Give your website the features it needs to succeed',
    billing_title: 'Let’s finish powering you up!',
    billing_subtitle: 'You’ve picked the right plan for you - let’s make it official.',
  },
  ra: {
    ...englishMessages.ra,
    auth: {
      ...englishMessages.ra.auth,
      email: 'Your email',
      password: 'Your password',
      sign_in: 'log in',
    },
  },
};
